const en = {
  '에이전트 수수료 기본값 설정': 'Agent Fee Default Settings',
  '추천 코드 가입과 하위 계정 자동 생성 시 적용할 기본 수수료율을 설정합니다.': 'Set the default fee rates applied to referral signups and automatically created child accounts.',
  '현재 계정': 'Current Account',
  '현재 수수료': 'Current Fee',
  '설정 상태': 'Status',
  '미설정': 'Not Configured',
  '설정됨': 'Configured',
  '하위 에이전트 설정 방식': 'Child Agent Setup Mode',
  '자율형과 고정 설정 중 하나를 선택합니다.': 'Choose either autonomous or fixed setup.',
  '자율형': 'Autonomous',
  '직속 하위 에이전트에게 수수료율만 넘기고, 이후 하위 설정은 해당 에이전트가 직접 결정합니다.': 'Assign only the initial rate to the direct child agent. That agent decides the rates below it.',
  '고정 설정': 'Fixed Setup',
  '현재 계정이 하위 에이전트와 유저 수수료를 모두 고정합니다. 하위 계정에는 설정 팝업이 표시되지 않습니다.': 'The current account fixes all child-agent and user rates. Child accounts will not see the setup popup.',
  '직속 유저': 'Direct User',
  '자율형 기본값': 'Autonomous Defaults',
  '직속 하위 에이전트가 자동 생성될 때 적용할 최초 수수료율입니다.': 'This is the initial rate applied when a direct child agent is created automatically.',
  'lv{from} → lv{to} 기본 수수료': 'lv{from} → lv{to} Default Fee',
  '하위 에이전트가 이후 자신의 하위 수수료를 직접 설정합니다.': 'The child agent will configure the rates below it.',
  'lv4는 추가 하위 에이전트가 없어 유저 가입 기본값만 설정합니다.': 'lv4 has no lower agent level, so only the user signup default is configured.',
  '전체 고정 기본값': 'Full Fixed Defaults',
  '하위 계정이 생성되는 레벨에 따라 아래 값을 자동 적용합니다.': 'The values below are applied automatically according to the level of the created account.',
  'lv{level} 고정 수수료': 'lv{level} Fixed Fee',
  '자동 생성되는 lv{level} 에이전트 노드에 적용됩니다.': 'Applied to automatically created lv{level} agent nodes.',
  '유저 고정 레이크백': 'Fixed User Rakeback',
  '고정 체인 아래에 생성되는 모든 신규 유저 노드에 적용됩니다.': 'Applied to all new user nodes created under the fixed chain.',
  '고정 하위 경로 합계': 'Fixed Child-Path Total',
  '유저 회원가입 타입': 'User Signup Type',
  '유저가 현재 에이전트의 추천 코드를 통해 직접 가입할 때 적용됩니다.': 'Applied when a user signs up directly through the current agent referral code.',
  '추천인 가입 유저 기본 수수료': 'Referral Signup User Default Fee',
  '고정 설정의 유저 값과 자동으로 동일하게 유지됩니다.': 'Automatically kept equal to the fixed user value.',
  'lv{level} → 유저로 직접 연결될 때 적용됩니다.': 'Applied when a user is connected directly under lv{level}.',
  '적용 방식': 'Application Mode',
  '직접 가입 유저': 'Direct Signup User',
  '상위 고정 정책이 적용된 하위 에이전트는 별도의 기본값 설정 팝업을 보지 않습니다.': 'Child agents governed by a parent fixed policy do not see a separate default-settings popup.',
  '하위 에이전트는 자신이 로그인한 뒤 다음 단계의 기본값을 별도로 설정할 수 있습니다.': 'The child agent can log in and configure defaults for the next level.',
  '수수료 기본값 저장에 실패했습니다.': 'Failed to save fee defaults.',
  '나중에 설정': 'Set Later',
  '저장 중...': 'Saving...',
  '기본값 저장': 'Save Defaults',
  '직접 입력': 'Manual Input',
  '수수료 기본값 설정': 'Set Fee Defaults',
  '수수료 기본값 수정': 'Edit Fee Defaults',
  '상위 고정 설정 적용 중': 'Parent Fixed Setup Active',
  '현재 브랜치 풀 한도': 'Current Branch Pool Limit',
  '직속 하위 에이전트 수수료가 현재 브랜치 풀을 초과합니다.': 'The direct child-agent fee exceeds the current branch pool.',
  '직속 유저 수수료가 현재 브랜치 풀을 초과합니다.': 'The direct-user fee exceeds the current branch pool.',
  '고정 수수료는 상위 브랜치 풀을 초과할 수 없습니다.': 'A fixed fee cannot exceed its parent branch pool.',
  '유저 고정 수수료는 상위 브랜치 풀을 초과할 수 없습니다.': 'The fixed user fee cannot exceed its parent branch pool.',
  '브랜치 풀': 'Branch Pool ',
  '현재 브랜치 풀': 'Current Branch Pool',
  '현재 노드의 브랜치 풀입니다. 형제 에이전트와 직속 유저 비율은 서로 합산하지 않습니다.': 'This is the current node branch pool. Sibling-agent and direct-user rates are independent and are not added together.',
};

const feeDefaultTranslations = {
  en,
  ko: {},
};

export default feeDefaultTranslations;
